<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="品类名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="品类简介" prop="titleIntro">
        <a-input v-model="form.titleIntro" placeholder="请输入" :maxLength="120" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { getObj, addObj, putObj } from '@/api/pressure/productCategory'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      data: [],
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        name: undefined,
        titleIntro: undefined,
        remark: undefined,
        sort: 99,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        name: [{ required: true, message: '请输入品类名称', trigger: 'blur' }],
        titleIntro: [{ required: true, message: '请输入品类简介', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() { },
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        name: undefined,
        titleIntro: undefined,
        remark: undefined,
        sort: 99,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加产品品类'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改产品品类'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false

              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
